import { Image, Info } from 'components';

export default function MarginOfErrorInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Person balancing on a left-right arrow while holding a red exclamation warning symbol on their shoulders" path="margin-of-error.png" title="Margin of Error" />
        <h5>Margin of Error</h5>
        <p>
            This tells you what you can conclude about the <span className="fst-italic">Population</span> based on your <span className="fst-italic">Sample Size</span>. It represents how inaccurate your <span className="fst-italic">Results</span> might be. A larger <span className="fst-italic">Margin of Error</span> represents a greater level of uncertainty about the <span className="fst-italic">Population</span>.
            <br/>
            <br/>
            <span className="fw-bold">Example:</span> If a survey with a <span className="fst-italic">Margin of Error</span> of 5% says that 20% of all Americans believe in UFOs, that means that exactly 20% of the people <span className="text-decoration-underline">in the <span className="fst-italic">Sample</span></span> believe in UFOs. But the percentage of Americans that believe in UFOs is somewhere between 15% and 25%.
            <br/>
            <br/>
            <span className="fw-bold">Note:</span> The <span className="fst-italic">Margin of Error</span> is sometimes called the <span className="fst-italic">Confidence Interval</span>, and should not to be confused with the <span className="fst-italic">Confidence Level</span>.
        </p>
    </Info>;

}